import util from "../../../util/util";
export default {
  props: {
    details: {
      type: Array,
      required: true
    }
  },
  computed: {
    columnWidth() {
      return Math.floor(100 / this.details.length) + "%";
    }
  },
  data: function () {
    return {};
  },
  methods: {
    formatTitle: function (dt) {
      let d = dt.split("-");
      return d[1] + "." + d[2];
    },
    money(val) {
      return util.formatMoney(val);
    }
  }
};
